/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChoiceToggle/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.module.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ChoiceToggle({
  children,
  viewPath = "/DesignSystem/ChoiceToggle",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  borderWidth = 2,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  onClick,
  paddingBottom = 8,
  paddingLeft = 15,
  paddingRight = 15,
  paddingTop = 8,
  width = 100,
  isSelected,
  backgroundColorSelected = "rgba(0,188,112, 0.1)",
  borderColorSelected = "rgba(0,188,112, 0.8)",
  backgroundColorHovered = "rgba(0, 234, 141, 0.05)",
  borderColorHovered = "rgba(0, 188, 112, 0.83)",
  alignSelf = "center",
  color = "#404040",
  fontSize = 12,
  lineHeight,
  fontWeight = 400,
  text = "Medicare",
  colorSelected = "rgb(0,150,89)",
  colorHovered = "rgba(0, 188, 112, 0.83)"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="ChoiceToggle.ChoiceToggle:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-ZGyQYT': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-ZGyQYT': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-ZGyQYT': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-ZGyQYT': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bw-7-ZGyQYT': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--ml-8-ZGyQYT': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-9-ZGyQYT': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-10-ZGyQYT': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--pb-11-ZGyQYT': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-12-ZGyQYT': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-13-ZGyQYT': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-14-ZGyQYT': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--w-15-ZGyQYT': typeof width === 'number' ? `${width}px` : width,'--bc-1-ZGyQYT': isSelected ? backgroundColorSelected : isHovered ? backgroundColorHovered : "#ffffff",'--bc-4-ZGyQYT': isSelected ? borderColorSelected : isHovered ? borderColorHovered : "#ebebeb"}}
 className={`views-block ${styles.ChoiceToggle1}`}
>
<span
  data-testid="ChoiceToggle.Text"
  data-view-path={viewPath}
 style={{'--as-16-ZGyQYT': alignSelf,'--fs-18-ZGyQYT': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--lh-19-ZGyQYT': lineHeight,'--fw-20-ZGyQYT': fontWeight,'--c-17-ZGyQYT': isSelected ? colorSelected : isHovered ? colorHovered : color}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}